import { KerningConfigData } from '../editorial/chaat/chaat-types';

export const defaultKerningConfigData: KerningConfigData = {
  minGapSize: 30,
  minSegmentLength: 1.5,
  forcedGapSize: 225,
};
